











































































import {Component, Vue, Prop, Mixins, Watch} from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import { Mutation } from 'vuex-module-decorators';
import {Actions} from '@/ts/store/Constants';
import Order from '@/ts/Order';
import CreditCards from '@/components/User/Wallet/CreditCards.vue';
import DateMethods from '@/mixins/DateMethods.vue';

@Component({
    components: {
        CreditCards,
    },
})

export default class OrderPay extends Mixins(DateMethods) {
    public autoPayStatus: boolean = false;
    public activeCard: any = 0;

    public selectedPaymentMethod: number = null;

    constructor() {
        super();
    }

    get order(): Order {
        return this.$store.getters['UserUpcomingPayments/getOrder'];
    }

    get cards(): any {
        return this.$store.getters['CreditCards/getCreditCards'];
    }

    @Watch('cards')
    public cardsChanged() {
        if (this.cards.length === 1) {
            this.activeCard = this.cards[0].id;
        }
    }



    public payForOrder() {
        const requestPayload = {
            orderId: this.order.id,
            paymentMethodId : this.activeCard,
            autoPayStatus : this.autoPayStatus,
        };

        this.$store.dispatch(Actions.PAY_FOR_ORDER, requestPayload);
    }

    public showAddPayments() {
        this.$emit('modalClosed');
        this.$store.commit(Mutations.SET_SHOW_WALLET_BLOCK_VISIBILITY, false);
        this.$store.commit(Mutations.SET_SHOW_CREDIT_CARDS_BLOCK_VISIBILITY, true);
        this.$store.commit(Mutations.SET_SHOW_TRANSACTIONS_BLOCK_VISIBILITY, true);
        this.$router.push('/user/wallet');
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_USER_CREDIT_CARDS);
        this.$store.dispatch(Actions.FETCH_STRIPE_PUBLIC_KEY);

        if (typeof this.$route.params.orderId !== 'undefined') {
            this.$store.dispatch(Actions.FETCH_ORDER_DETAILS, this.$route.params.orderId);
        }
    }


}
